import { render, staticRenderFns } from "./InvoiceProfit.vue?vue&type=template&id=53e6279c&"
import script from "./InvoiceProfit.vue?vue&type=script&lang=js&"
export * from "./InvoiceProfit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports